import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {environment} from '../../environment/environment';
export type QueryModel = Record<string, any>;

@Injectable({providedIn: 'root'})
export class HttpService {
    constructor(
        protected http: HttpClient
    ) {
    }
    private createHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }

    private createFormDataOptions(): HttpHeaders {
        return  new HttpHeaders();
    }

    get(url: string, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }

        return this.http.get(environment.apiUrl + url, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }

    getAuth(url: string, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }

        return this.http.get(environment.authUrl + url, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }


    post(url: string, data: any,  queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.post(environment.apiUrl + url, data, {
            headers: this.createHeaders(),
            params: params
            })
            .pipe(
                catchError(this.handleError)
            );
    }

    postAuth(url: string, data: any,  queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.post(environment.authUrl + url, data, {
            headers: this.createHeaders(),
            params: params
        })
            .pipe(
                catchError(this.handleError)
            );
    }

    put(url: string, data: any, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.put(environment.apiUrl + url, data, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }

    putAuth(url: string, data: any, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.put(environment.authUrl + url, data, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }

    delete(url: string): Observable<any> {
        return this.http.delete(environment.apiUrl + url, { headers: this.createHeaders() })
            .pipe(
                catchError(this.handleError)
            );
    }

    formDataPost(url: string, data: any): Observable<any> {
        return this.http.post(environment.apiUrl + url, data, {headers: this.createFormDataOptions()})
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Observable<never> {
        throw error;
    }
}
